import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Hard-deletes a single notification owned by the current user.
 *
 * @param instance - Ky HTTP instance.
 * @param id - Notification id.
 * @returns OperationResult (no payload).
 */
export const deleteNotification = async (instance: KyInstance, id: number): Promise<OperationResult> => {
  try {
    return await instance.delete<OperationResult>(formatString(Uri.notifications.byId, String(id))).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
